export default {
    "version":"2026-01-21",
    "bucket":"https://custom-images.mediadirhub.com",
    "lang":"en",
    "keyString":"gajhsdjVJAXCAGX@#@#!@@#2342FE@#3",
    "postURL":"https://api.mediadirhub.com/api-docs",
    "manifest":"https://snappy.appypie.com/webservices/manifest-pwa.php",
    "apiFetch":"https://api-fetch.mediadirhub.com",
    "appkitCDN":"https://media.mediadirhub.com/appkit-assets",
    "appkitPath":"https://media.mediadirhub.com/appkit-staging/assets",
    "projects":[
        {"name":"karma trust", "domain":"karmtrust.org"}
    ],
    "pageKeys":[
        {"key":"name", "type":"text", "text":"Name", "placeholder":"Page Name"},
        {"key":"url", "type":"text", "text":"URL", "placeholder":"/your-page"},
        {"key":"type", "type":"select", "text":"Type", "options":[
            {"value":"static", "text":"Static"},
            {"value":"editor", "text":"Editor"},
            {"value":"html", "text":"HTML"}
        ]},
        {"key":"title", "type":"text", "text":"Title", "placeholder":"SEO Title"},
        {"key":"description", "type":"textarea", "text":"Description", "placeholder":"SEO Description"},
        {"key":"keywords", "type":"text", "text":"Keywords", "placeholder":"keyword1, keyword2"},
        {"key":"schemaMarkup", "type":"textarea", "text":"Schema Markup", "placeholder":`{"@context":"https://schema.org","@type":"WebPage"}`},
        {"key":"domain", "type":"hidden", "text":"Domain", "placeholder":"Domain"},
        {"key":"status", "type":"tabs", "text":"Status", "options":[
            {"value":1, "text":"Active"},
            {"value":0, "text":"Inactive"}
        ]}
    ],
    "userKeys":[
        {"key":"name", "type":"text", "text":"Name", "placeholder":"Name!"},
        {"key":"email", "type":"text", "text":"Email", "placeholder":"Email!"},
        {"key":"phone", "type":"text", "text":"Phone", "placeholder":"Phone!"},
        {"key":"password", "type":"password", "text":"Password", "placeholder":"Password!"},
        
        {"key":"role", "type":"select", "text":"Type", "options":[
            {"value":"user", "text":"User"},
            {"value":"admin", "text":"Admin"}
        ]},
        {"key":"status", "type":"tabs", "text":"Status", "options":[
            {"value":1, "text":"Active"},
            {"value":0, "text":"Inactive"}
        ]}
    ],
    "blockKeys":[
        {"key":"page", "type":"select", "text":"Page", "placeholder":"/your-page", "options":[
  { "value": "home", "text": "Home" },
  { "value": "about", "text": "About" },
  { "value": "contact", "text": "Contact" },
  { "value": "map", "text": "Map" },
  { "value": "testimonial", "text": "Testimonial" },
  { "value": "website", "text": "Website" },
  { "value": "faq", "text": "Faq" },
  { "value": "pricingplan", "text": "Pricingplan" },
  { "value": "religion-worship", "text": "Religion Worship" },
  { "value": "ai-home", "text": "Ai Home" }
]},
        {"key":"type", "type":"select", "text":"Type", "placeholder":"Page Name", "options":[
  { "value": "listings", "text": "Listings" },
  { "value": "banners", "text": "Banners" },
  { "value": "videos", "text": "Videos" },
  { "value": "photos", "text": "Photos" },
  { "value": "testimonials", "text": "Testimonials" },
  { "value": "services", "text": "Services" },
  { "value": "promotions", "text": "Promotions" },
  { "value": "faqs", "text": "Faqs" },
  { "value": "pricing-plans", "text": "Pricing Plans" },
  { "value": "forms", "text": "Forms" }
]},
        {"key":"name", "type":"text", "text":"Name", "placeholder":"Enter name"},
        {"key":"key", "type":"text", "text":"KEY", "placeholder":"Enter key"},
        {"key":"status", "type":"tabs", "text":"Status", "options":[
            {"value":1, "text":"Active"},
            {"value":0, "text":"Inactive"}
        ]}
    ],
    "templateKeys":[
        {"key":"title", "type":"text", "text":"Title", "placeholder":"Enter title"},
        {"key":"page", "type":"select", "text":"Page", "placeholder":"Select Page Type", "options":[
            { "value": "homenew", "text": "Home" },
            { "value": "aboutai", "text": "About" },
            { "value": "contactai", "text": "Contact" },
            { "value": "mapai", "text": "Map" },
            { "value": "testimonialai", "text": "Testimonial" },
            { "value": "websiteai", "text": "Website" },
            { "value": "faqai", "text": "Faq" },
            { "value": "pricingplanai", "text": "Pricingplan" }
        ]},
        {"key":"category", "type":"select", "text":"Category", "placeholder":"Select Category", "options":[
            { "value": "business", "text": "Business" },
            { "value": "radio-podcast", "text": "Radio/Podcast" },
            { "value": "restaurant-food", "text": "Restaurant & Food" },
            { "value": "online-store", "text": "Online Store" },
            { "value": "events", "text": "Events" },
            { "value": "education", "text": "Education" },
            { "value": "religion-worship", "text": "Religion/Worship" },
            { "value": "health-wellness", "text": "Health & Wellness" },
            { "value": "news-magazine", "text": "News & Magazine" },
            { "value": "location-places", "text": "Location & Places" },
            { "value": "dating", "text": "Dating" },
            { "value": "others", "text": "Others" }
        ]},
        {"key":"status", "type":"tabs", "text":"Status", "options":[
            {"value":1, "text":"Active"},
            {"value":0, "text":"Inactive"}
        ]}
    ]
}